<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light" style="height: 45px;">
      <!-- <div>
         <div class="navbar-nav">
          <router-link :to="{name: 'Login'}" class="nav-item nav-link">{{$t('message.logIn')}}</router-link>
        </div> 
      </div> -->
      <div class="langs">
        <a @click="changeLocale('en')" :class="{active: computedCurrentLocale === 'en', langButton: true}" href="#">EN</a>
        <a @click="changeLocale('de')" :class="{active: computedCurrentLocale === 'de', langButton: true}" href="#">DE</a>
        <a @click="changeLocale('it')" :class="{active: computedCurrentLocale === 'it', langButton: true}" href="#">IT</a>
        <a @click="changeLocale('fr')" :class="{active: computedCurrentLocale === 'fr', langButton: true}" href="#">FR</a>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: "Navbar",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
  .langs {
    position: absolute;
    right: 30px;
    height: 100%;
  }
  .active{
    background: #d1d1d1;
    color: white !important;
  }
  .langButton{
    display: inline-block;
    height: 100%;
    padding: 13px;
  }
</style>
